import axios from "axios";
import config from "../config";
import { SearchResponse } from "./ResponseModels/SearchResponse";

export async function GetFollowingWoModel(
  pageSize: number,
  lastEvaluatedKey: string = null
) {
  let response = null;
  response = axios
    .get<SearchResponse>(config.getFollowingEndpoint, {
      params: {
        pageSize: pageSize,
        lastEvaluatedKey: lastEvaluatedKey,
      },
    })
    .catch((e) => {
      console.error("There was an error!", e);
    });

  return response;
}
